import { addEventParamsToUrl } from '@rover/utilities/url';
import axios from 'axios';

import SearchLocationView from './search_location_view';
import DatePickerView from '../date_picker_view';
import ModalView from '../../../components/rover_modal';
import Rover from '@rover/globals/Rover';
import Backbone from '@rover/globals/backbone';
import dataLayer from '@rover/globals/dataLayer';
import _ from '@rover/globals/underscore';
import $ from '@rover/globals/jquery';
import { SERVICE_TYPE_CHOICES } from '../../../constants/serviceConstants';

export default ModalView.extend({
  primaryButtonClicked: false,
  bindings: {
    '.js-quick-match-dog-walking': {
      classes: {
        hidden: {
          observe: ['service_type', 'quick_match_dog_walking'],
          onGet(values) {
            const serviceType = values[0];
            const quickMatchDogWalking = values[1];
            const shouldHide =
              serviceType !== SERVICE_TYPE_CHOICES.walking || !quickMatchDogWalking;
            if (!shouldHide) {
              dataLayer.push({
                event: 'quick-match-owner-preferences-modal-callout-display',
                nonInteractive: true,
              });
            }
            return shouldHide;
          },
        },
      },
    },
  },
  initialize(options) {
    ModalView.prototype.initialize.call(this, options); // super()
    this.serviceTypes = options.serviceTypes;
    this.walkingConfiguration = options.walkingConfiguration;
    this.$modal.modal.Constructor.prototype.checkScrollbar = function() {};
    this.$wizard = this.$modal.find('.search-wizard-modal');
    this.$wizard.show();
    this.$wizard.find('.datepicker').datepicker({});
    this.model = new Backbone.Model({
      service_type: Rover.query.get('service_type'),
      start_date: Rover.query.get('start_date'),
      end_date: Rover.query.get('end_date'),
      quick_match_dog_walking: false,
    });
    this.updateQuickMatchDogWalkingFromConfiguration(this.walkingConfiguration);
    this.stickit();
    this.sendInitEventNotification();
    this.initPrimaryButton();
    this.initServices();
    this.initAddress();
    this.initCalendar();
    this.initSizes();
    this.initAge();
    this.initPreferences();
    this.listenTo(
      this.searchLocationView,
      'geocode:complete',
      _.bind(this.updateQuickMatchDogWalking, this)
    );
  },
  updateQuickMatchDogWalking(searchParams) {
    axios
      .get(Rover.urls.assignmentConfiguration, {
        params: {
          service_type: SERVICE_TYPE_CHOICES.walking,
          centerlat: searchParams.centerlat,
          centerlng: searchParams.centerlng,
        },
      })
      .then(response => {
        this.updateQuickMatchDogWalkingFromConfiguration(response.data);
      })
      .catch(() => {
        this.model.set('quick_match_dog_walking', false);
      });
  },
  updateQuickMatchDogWalkingFromConfiguration(configuration) {
    const $cta = this.$('.js-quick-match-dog-walking-cta');
    const isHybrid =
      configuration.is_quick_match_enabled && !configuration.is_quick_match_exclusive;
    const url = addEventParamsToUrl(configuration.landing_page_url, [
      {
        event: 'quick-match-owner-preferences-modal-get-started',
      },
    ]);
    $cta.attr('href', url);
    if (configuration.default_promo) {
      const title = configuration.default_promo.text.search_callout_title;
      if (title) {
        this.$('.js-quick-match-callout-title').text(title);
      }
      this.$('.js-quick-match-description-prefix').removeClass('hidden');
    } else {
      this.$('.js-quick-match-description-prefix').addClass('hidden');
    }
    this.model.set('quick_match_dog_walking', isHybrid);
  },
  initPrimaryButton() {
    this.$button = this.$modal.find('.modal-footer > .rover-btn-primary');
    this.$button.html('Next <i class="rover-icon rover-icon-in-right"></i>');
    this.$button.addClass('arrow-btn');

    if (this.hasNextPage()) {
      this.$button.click(() => {
        this.showSearchButton();
        this.showNextPage();
        $('html, body').animate({ scrollTop: 0 }, 'fast');
      });
    } else {
      this.showSearchButton();
    }

    this.primaryButtonClicked = false;
  },
  getServiceType(el) {
    let target = this.$wizard.find('.services .rover-btn.active > input');
    if (el) target = el;
    return _.findWhere(this.serviceTypes, { slug: $(target).val() });
  },
  initServices() {
    const service = Rover.query.get('service_type');
    this.initButtonGroup('.services', service);

    this.$wizard.find('.services .rover-btn > input').change(event => {
      const serviceType = this.getServiceType(event.currentTarget);
      this.model.set('service_type', serviceType.slug);

      if (this.shouldShowPreferences(serviceType)) {
        this.showPreferences();
      } else {
        this.hidePreferences();
      }

      if (this.shouldShowWeek(serviceType)) {
        this.setWeekService(this.getServiceName(serviceType));
        this.showWeek();
      } else {
        this.showCalendar();
      }
    });

    this.$wizard.find(`.services .rover-btn > input[value="${service}"]`).trigger('change');
  },
  initAddress() {
    const location = $('<div/>')
      .html(Rover.query.get('location'))
      .text();
    this.$wizard.find('.address > input').val(location);

    this.searchLocationView = new SearchLocationView({
      el: '.search-wizard-modal .address',
      model: Rover.query,
      searchResults: Rover.searchResults,
      isSearchEnabled: false,
      triggerGeoCodeOnChange: true,
    });
  },
  initCalendar() {
    this.datePickerView = new DatePickerView({
      el: this.$wizard.find('.calendar .js-daterangepicker'),
      query: this.model,
    });
  },
  initSizes() {
    this.$wizard.find('.weight .rover-btn > input').each((index, el) => {
      const size = $(el).attr('name');
      const isChecked = Rover.query.get(size);
      $(el).prop('checked', isChecked);

      if (isChecked) {
        $(el)
          .parent()
          .addClass('active');
      }
    });
  },
  initAge() {
    const age = Rover.query.get('puppy') ? 'puppy' : 'adult';
    this.initButtonGroup('.age', age);
  },
  initPreferences() {
    const likesCats = Rover.query.get('no_cats') ? 'no' : 'yes';
    const likesDogs = Rover.query.get('person_does_not_have_dogs') ? 'no' : 'yes';
    this.initButtonGroup('.cat-prefs', likesCats);
    this.initButtonGroup('.dog-prefs', likesDogs);
  },
  initButtonGroup(selector, value) {
    const $selectedInput = this.$wizard.find(`${selector} .rover-btn > input[value="${value}"]`);
    $selectedInput.prop('checked', true);
    $selectedInput.parent().addClass('active');
  },
  shouldShowWeek(serviceType) {
    return serviceType.supports_day_of_week_search;
  },
  showWeek() {
    this.$wizard.find('.calendar').hide();
    this.$wizard.find('.week').show();
  },
  showCalendar() {
    this.$wizard.find('.week').hide();
    this.$wizard.find('.calendar').show();
    this.$wizard.find('.calendar .js-date-picker').on('focus', _.bind(this.onPickerFocus, this));
  },
  onPickerFocus() {
    // put the attachMouseListener function at the end of the
    // execution queue so that the JQuery can finish rendering the
    // date picker before we attach the listener
    setTimeout(_.bind(this.attachMouseListener, this));
  },
  attachMouseListener() {
    $('#ui-datepicker-div a').on('mousedown', e => {
      e.preventDefault();
    });
  },
  getServiceName(serviceType) {
    return {
      'doggy-day-care': 'day care',
      'drop-in': 'a drop-in',
      'dog-walking': 'a walk',
    }[serviceType.slug];
  },
  setWeekService(service) {
    this.$wizard.find('.week > label > .service').text(service);
  },
  shouldShowPreferences(serviceType) {
    const hostingTypes = ['overnight-boarding', 'doggy-day-care'];
    return hostingTypes.indexOf(serviceType.slug) !== -1;
  },
  showPreferences() {
    this.$wizard.find('.cat-prefs').show();
    this.$wizard.find('.dog-prefs').show();
  },
  hidePreferences() {
    this.$wizard.find('.cat-prefs').hide();
    this.$wizard.find('.dog-prefs').hide();
  },
  showSearchButton() {
    this.$button.html('Search Now');

    this.$button.off('click').click(() => {
      this.$modal.modal('hide');
      this.onSearch.apply(this);
      $('html, body').animate({ scrollTop: 0 }, 'fast');
    });
  },
  showNextPage() {
    this.$wizard.find('.page-1').hide();
    this.$wizard.find('.page-2').show();
    this.sendNextButtonEventNotification();
  },
  hasNextPage() {
    return !(Rover.query.get('pet') && Rover.query.get('pet').length);
  },
  onSearch() {
    const $search = this.searchLocationView.$input;
    if ($search.data('geocoded') !== 'geocoded') {
      $search.on('geocoded', () => {
        this.onSearch();
      });
      this.searchLocationView.geocodeLocation();
      return;
    }
    const serviceType = this.getServiceType();
    const isPuppy = this.$wizard.find('.age .rover-btn.active > input').val() === 'puppy';

    let updates = {
      service_type: serviceType.slug,
      puppy: isPuppy,
    };

    if (this.searchLocationView.searchParams) {
      updates = {
        ...updates,
        ...this.searchLocationView.searchParams,
      };
    }

    if (this.shouldShowWeek(serviceType)) {
      this.$wizard.find('.week .rover-btn').each((index, el) => {
        const day = $(el)
          .find('input')
          .prop('name');
        const isChecked = $(el).hasClass('active');
        updates[day] = isChecked;
      });
    } else {
      const startDate = $('#start-date-modal').val();
      const endDate = $('#end-date-modal').val();
      updates.start_date = startDate;
      updates.end_date = endDate;
    }

    this.$wizard.find('.weight .rover-btn').each((index, el) => {
      const size = $(el)
        .find('input')
        .prop('name');
      const isChecked = $(el).hasClass('active');
      updates[size] = isChecked;
    });

    if (this.shouldShowPreferences(serviceType)) {
      const allowCats = this.$wizard.find('.cat-prefs .rover-btn.active > input').val() !== 'no';
      updates.no_cats = !allowCats;

      const allowOtherDogs =
        this.$wizard.find('.dog-prefs .rover-btn.active > input').val() !== 'no';
      updates.person_does_not_have_dogs = !allowOtherDogs;
      updates.accepts_only_one_client = !allowOtherDogs;
    }

    Rover.query.set(updates);

    this.primaryButtonClicked = true;
    this.sendSearchEventNotification();
  },
  onModalHidden() {
    if (!this.primaryButtonClicked) {
      this.sendCloseEventNotification();
    }
  },
  sendInitEventNotification() {
    dataLayer.push({
      event: 'search-owner-preferences-display-search-wizard',
      nonInteractive: true,
    });
  },
  sendNextButtonEventNotification() {
    dataLayer.push({ event: 'search-owner-preferences-next' });
  },
  sendCloseEventNotification() {
    dataLayer.push({ event: 'search-owner-preferences-close' });
  },
  sendSearchEventNotification() {
    Rover.views.eventTracker.sendSearchEventNotification(
      'search-owner-preferences-search',
      Rover.query.toJSON()
    );
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/search_wizard_modal.js